import React from "react";
import { ReactComponent as DangerAlertSVG } from "go-core/images/svg/alert.svg";
import { ReactComponent as WarningAlertSVG } from "go-core/images/svg/warning-alert.svg";
import { OrganizationAlert } from "../../../../../services/Api/Organization/organizationTypes";

interface Props {
	alert: OrganizationAlert;
}

const OrganizationAlertItem = ({ alert }: Props) => {
	return (
		<div>
			{alert.type && alert.title && (
				<>
					<div className="d-flex alerts-card-item">
						{alert.type === "WARNING" ? <WarningAlertSVG /> : <DangerAlertSVG />}
						<span>{alert.title}</span>
					</div>
					<hr />
				</>
			)}
		</div>
	);
};

export default OrganizationAlertItem;
